
<template>
    <div class="tableIngresos">
        <vs-row>
            <vs-alert v-if="mostrarError">
            <template #title>
                {{mensajeError}} 
            </template>
            </vs-alert>
            <vs-col w="12">
                <vs-button
                    v-if="users != ''"
                    color="#55ce63"
                    relief 
                    :loading="excelLoading"
                    @click="getExcelCalificaciones()"
                    class="ml-auto"
                >
                    <i class="fas fa-download mr-2"></i> Descargar reporte
                </vs-button>

                <vs-input v-if="users != ''" class="ml-auto searchWidth" v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
                <div style="max-width: 100%;">
                    <vs-table striped clas="table-responsive"  v-dragscroll="{ target: '.vs-table', active: true }">
                        <template #thead>
                        <vs-tr>
                            <vs-th width="150px">
                                Alumno
                            </vs-th>
                            <vs-th width="50">
                                Salón
                            </vs-th>
                            <vs-th v-for="(item, i) in materias" :key="i">
                                {{item.materia}}
                            </vs-th>
                            <vs-th v-if="materias.length == 0">
                                Materias
                            </vs-th>
                            <!-- <vs-th v-if="rubro == 'calificacion'" width="75px">
                                Reprobadas
                            </vs-th> -->
                            <vs-th v-if="rubro == 'calificacion'" width="50px">
                                Promedio
                            </vs-th>
                        </vs-tr>
                        </template>
                        <template #tbody>
                        <vs-tr
                            :key="i"
                            v-for="(tr, i) in users"
                            :data="tr"
                        >
                            <vs-td>
                                <md-content class="docientos">
                                    <md-chip class="mb-1 fontMedium mini-chip col-blue"><small class="text-uppercase">No. Lista: </small><strong>{{tr.numero_lista}}</strong></md-chip>
                                    <p class="mb-0"><strong>{{tr.nombre}}</strong></p>
                                    <p class="mb-0"><small class="text-uppercase">Matrícula: </small><strong>{{tr.matricula}}</strong></p>
                                    <vs-button
                                        v-if="tr.persona_id" 
                                        transparent
                                        blank
                                        :href="`/panel/alumno/${window.btoa(tr.persona_id)}/institucion/${window.btoa(institucion)}?valor=ver-calificaciones`"
                                    >
                                        <i class="fas fa-address-card mr-2"></i>  Ir a boleta
                                    </vs-button>
                                </md-content>
                            </vs-td>
                            <vs-td>
                                <md-content class="ochenta">
                                    <md-chip class="mb-1 fontMedium mini-chip col-purple"><strong>{{tr.salon}}</strong></md-chip>
                                </md-content>
                            </vs-td>
                            <vs-td class="text-center" v-for="(cal, i) in tr.calificaciones" :key="i">
                                <md-content class="ochenta"  v-if="tr.calificaciones">
                                    <p class="mb-0 fs-14">{{cal.calificacion}}</p>
                                </md-content>
                            </vs-td>
                            <!-- <vs-td class="text-center" v-if="rubro == 'calificacion'">
                                <p class="fs-14 mb-0" :style="tr.reprobadas >= 1 ?'color: #C0392B' : ''"><i>{{tr.reprobadas}}</i></p>
                            </vs-td> -->
                            <vs-td class="text-center" v-if="rubro == 'calificacion'">
                                <p class="fs-14 mb-0"><i>{{tr.promedio}}</i></p>
                            </vs-td>
                        </vs-tr>
                        </template>
                        <template #notFound>
                            No hay información
                        </template>
                    </vs-table>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
import reportes from '../../../../api/requests/reportes.js'
import { dragscroll } from 'vue-dragscroll'
export default {
    props: [
        'institucion',
        'cicloEscolar',
        'programa',
        'periodo',
        'grupo',
        'rubro',
        'grupoAdmin',
        'ejecutar',
        'grado',
        'periodo_calculado'
    ],
    data:() => ({
        users: [],
        search: '',
        loadingExcel: false,
        materias: [],
        mostrarError: false,
        excelLoading: false,
        mensajeError: ''
    }),
    directives: {
       'dragscroll': dragscroll
    },
    methods:{
        async getExcelCalificaciones() {
            const loading = this.$vs.loading()
            try {
                
                let params = {
                    institucion_id: this.institucion,
                    ciclo_escolar_id: this.cicloEscolar,
                    programa_id: this.programa,
                    rubro: this.rubro,
                    type_response: 'file'
                }
                if(this.grupoAdmin != ''){
                    params.grupo_administrativo_id = this.grupoAdmin
                }
                if(this.grupo != ''){
                    params.bloque_academico_id = this.grupo
                }
                if(this.grado != ''){
                    params.grado_id = this.grado
                }
                if(this.periodo != ''){
                    params.configuracion_evaluacion_id = this.periodo
                }
                if(this.periodo_calculado != ''){
                    params.detalle_componente_id = this.periodo_calculado
                }
                const response = await reportes.getInfoCalificaciones(params)
                console.log(response)
                loading.close()
                if(response){
                    window.location.href = response.request.responseURL;
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Éxito',
                        text: 'Descarga lista'
                    })
                }
            }
            catch{
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: 'bottom-right',
                    title: 'Hubo un error inesperado'
                })
            }
        },
        async getInfoCalificaciones(){
            const loading = this.$vs.loading()
            try {
                this.mostrarError = false
                const params = {
                    institucion_id: this.institucion,
                    ciclo_escolar_id: this.cicloEscolar,
                    programa_id: this.programa,
                    rubro: this.rubro,
                    type_response: 'online'
                }
                if(this.grupoAdmin != ''){
                    params.grupo_administrativo_id = this.grupoAdmin
                }
                if(this.grupo != ''){
                    params.bloque_academico_id = this.grupo
                }
                if(this.grado != ''){
                    params.grado_id = this.grado
                }
                if(this.periodo != ''){
                    params.configuracion_evaluacion_id = this.periodo
                }
                if(this.periodo_calculado != ''){
                    params.detalle_componente_id = this.periodo_calculado
                }
                const {data: response} = await reportes.getInfoCalificaciones(params)
                loading.close()
                this.users = response
            } catch (error) {
                loading.close()
                this.users = []
                this.mostrarError = true
                this.mensajeError = error.response.data.message
            }
        },
        getMaterias(){
            if(this.users != ''){
                this.materias = this.users[0].calificaciones
            }else{
                this.materias = []
            }
        }
    },
    watch: {
        ejecutar(){
            this.getInfoCalificaciones()
        },
        users(){
            this.getMaterias()
        }
    }
}
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .searchWidth{
        @media only screen and (max-width: 768px) {
            width: 100%;
        }
        @media only screen and (min-width: 768px) {
            width: 30%;
        }
    }
    .ochenta{
        width: 80px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .cien {
        width: 100px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .cienCincuenta {
        width: 150px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .docientos {
        width: 200px;
        background: none;
        justify-content: center;
        align-items: center;
    }
    .trecientos{
        width: 300px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;

    }

    .fs-14{
        font-size: 14px;
        font-weight: 600;
    }

    .mdChip{
        background: rgba($color: #000000, $alpha: 0.5);
        margin:1.7% 0;
        padding: 2% 6%;
        text-align: center;
        border-radius: 15px;
        font-size: 11px;
    }
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

</style>
<style scoped>
    /* .vs-table-content {
        overflow-x: auto !important;
    } */
    .vs-table{
        overflow-x: none;
    }

    .vs-table__tbody{
        vertical-align: top !important;
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }
    .docientos {
        width: 200px;
        background: none;
        justify-content: center;
        align-items: center;
    }
    .ochenta {
        width: 80px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .trecientos{
        width: 300px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;

    }

</style>

<style>
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

</style>
        